export default __webpack_public_path__ + "static/media/loader_10_d.9df0124d.png";